'use strict'

/**
 * @function getSrc
 * @param {Object} picture
 * @returns {string} img src
 */
export function getSrc (picture) {
  let windowSize = window.innerWidth
  let sources = []
  
  // get sources config
  if (picture.childNodes) {
    for (let k = 0; k < picture.childNodes.length; k++) {
      if (picture.childNodes[k].tagName === 'SOURCE') {
        sources.push(picture.childNodes[k])
      }
    }
    for (let i = 0; i < sources.length; i++) {
      let sourceData = sources[i].getAttribute('media')
                                 .replace('(', '')
                                 .replace(')', '')
                                 .replace('px', '')
                                 .split(':')
      let sourceType = sourceData[0]
      let sourceValue = !isNaN(Number(sourceData[1]))
        ? Number(sourceData[1])
        : sourceData[1]
      switch (sourceType) {
        case 'max-width': {
          if (windowSize < sourceValue) {
            return sources[i].getAttribute('srcset')
          }
        }
          break
        case 'min-width': {
          if (windowSize >= sourceValue) {
            return sources[i].getAttribute('srcset')
          }
        }
          break
        default:
          break
      }
    }
  }
  return false
}


// WEBPACK FOOTER //
// ./src/apps/Front/private/js/utils/responsiveImage.js